export default "__VITE_ASSET__665517ab__"